import { NotFound } from 'component/errors/not-found';
import { articleModuleQuery, useModule } from 'system/structure-modules';
import { useEnabledFeatures } from 'util/features-hooks';

export default function ArticleManageVideoVotingScreen() {
    const { VideoVotingAssignmentScreen } = useModule(articleModuleQuery);
    const { videovotingArticle } = useEnabledFeatures();
    if (!videovotingArticle) {
        return <NotFound />;
    }

    return <VideoVotingAssignmentScreen />;
}
